// Copyright (c) 2016 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const StatesInCountry = t.list(KeyValuePair, 'StatesInCountry');

export const getDefaultState = () => new StatesInCountry([]);

export default StatesInCountry;



// WEBPACK FOOTER //
// ./src/product/status-change-request/state/states-in-country.js